import React, { useState, useEffect } from "react";
import {
  Modal,
  Paper,
  Typography,
  TextField,
  IconButton,
  Grid,
  CardContent,
  CardMedia,
  InputLabel,
  MenuItem,
  FormControl,
  Select,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import InfoIcon from "@mui/icons-material/Info";
import { LoadingButton } from "@mui/lab";
import { toastAlert } from "../../../utils/AlertContext";
import { getUpdateCartonURL } from "../../../utils/ConstantsURL";

export const EditCarton = ({
  token,
  open,
  close,
  carton,
  selectedDate,
  selectedIdSection,
  sections,
  refresh,
}) => {
  const [cartonData, setCartonData] = useState({
    autor: "",
    fecha: "",
    testigo: "",
    seccion_id: "",
    image: null,
    url: null,
  });
  const [newImage, setNewImage] = useState(null);
  const [loading, setLoading] = useState(false);

  const validate = () => {
    return (
      !cartonData.autor ||
      !cartonData.fecha ||
      !cartonData.testigo ||
      !cartonData.seccion_id ||
      !cartonData.url
    );
  };

  const handleUpdate = async () => {
    setLoading(true);
    try {
      const formData = new FormData();
      formData.append("autor", cartonData.autor);
      formData.append("fecha", cartonData.fecha);
      formData.append("testigo", cartonData.testigo);
      formData.append("seccion_id", cartonData.seccion_id);

      if (newImage) {
        formData.append("image", newImage);
      }

      const response = await fetch(getUpdateCartonURL(carton.id), {
        method: "PUT",
        headers: {
          Authorization: `Bearer ${token}`,
        },
        body: formData,
      });

      if (!response.ok) {
        toastAlert("Error al enviar la petición", "error");
        setLoading(false);
        return;
      }
      toastAlert("Carton editado correctamente", "success");
      setLoading(false);
      close();
      refresh();
    } catch (error) {
      toastAlert("Error al enviar la petición: " + error, "error");
      setLoading(false);
    }
  };

  useEffect(() => {
    if (carton && open) {
      setCartonData({
        ...carton,
        fecha: selectedDate || carton.fecha,
        seccion_id: carton.seccion_id || selectedIdSection,
      });
    }
  }, [carton, selectedDate, selectedIdSection, open]);

  const handleChange = (field) => (event) => {
    setCartonData({ ...cartonData, [field]: event.target.value });
  };

  const handleImageChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      setNewImage(file);
      const imageUrl = URL.createObjectURL(file);
      setCartonData((prevData) => ({ ...prevData, image: imageUrl }));
    }
  };

  const handleImageClick = () => {
    document.getElementById("imageInput").click();
  };

  if (!carton) return null;

  return (
    <Modal open={open} onClose={close}>
      <Paper
        elevation={2}
        style={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          padding: "20px",
          width: "70%",
          height: "80%",
          display: "flex",
          flexDirection: "column",
          outline: "none",
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: "20px",
          }}
        >
          <Typography variant="h6">Editar Carton</Typography>
          <IconButton onClick={close}>
            <CloseIcon />
          </IconButton>
        </div>

        <div style={{ flex: 1, overflowY: "auto" }}>
          <Grid container spacing={5} style={{ padding: "15px" }}>
            <Grid item xs={12} md={4}>
              <CardMedia
                component="img"
                style={{ width: "100%", height: "auto", borderRadius: "25px" }}
                image={cartonData.url || "/icon.png"}
                alt={cartonData.image}
                onClick={handleImageClick}
              />
              <input
                type="file"
                id="imageInput"
                style={{ display: "none" }}
                accept="image/*"
                onChange={handleImageChange}
              />

              <Typography
                variant="body1"
                color="textSecondary"
                component="div"
                style={{
                  marginTop: "10px",
                  display: "flex",
                  alignItems: "center",
                  fontSize: "14px",
                }}
              >
                <InfoIcon style={{ marginRight: "5px", fontSize: "20px" }} />{" "}
                Presiona la imagen para cambiarla
              </Typography>
            </Grid>
            <Grid item xs={12} md={8}>
              <CardContent style={{ padding: "0" }}>
                <div style={{ marginBottom: "10px" }}>
                  <Typography
                    variant="h6"
                    color="textSecondary"
                    component="div"
                  >
                    Autor del carton:
                  </Typography>
                  <TextField
                    variant="outlined"
                    fullWidth
                    value={cartonData.autor}
                    onChange={handleChange("autor")}
                    margin="dense"
                  />
                </div>
                <div style={{ marginBottom: "10px" }}>
                  <Typography
                    variant="h6"
                    color="textSecondary"
                    component="div"
                  >
                    Testigo:
                  </Typography>
                  <TextField
                    variant="outlined"
                    fullWidth
                    value={cartonData.testigo}
                    onChange={handleChange("testigo")}
                    margin="dense"
                  />
                </div>
                <div style={{ marginBottom: "10px", display: "flex", gap: "10px" }}>
                  <TextField
                    label="Fecha"
                    variant="outlined"
                    fullWidth
                    type="date"
                    value={cartonData.fecha}
                    onChange={handleChange("fecha")}
                    margin="dense"
                    InputLabelProps={{ shrink: true }}
                  />
                  <FormControl fullWidth>
                    <InputLabel id="edit-seccion-label">Sección</InputLabel>
                    <Select
                      labelId="edit-seccion-label"
                      value={cartonData.seccion_id}
                      onChange={handleChange("seccion_id")}
                      label="Sección"
                    >
                      {sections.map((item) => (
                        <MenuItem key={item.ID_SECCION} value={item.ID_SECCION}>
                          {item.NOMBRE_SECCION}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </div>
              </CardContent>
            </Grid>
          </Grid>
        </div>

        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            marginTop: "20px",
          }}
        >
          <LoadingButton
            variant="contained"
            color="primary"
            onClick={handleUpdate}
            loading={loading}
            disabled={validate()}
          >
            Confirmar
          </LoadingButton>
        </div>
      </Paper>
    </Modal>
  );
};
